<form [formGroup]="aFormGroup">
    <ngx-recaptcha2 #captchaElem
      [siteKey]="siteKey"
      (reset)="handleReset()"
      (expire)="handleExpire()"
      (error)="handleError()"
      (load)="handleLoad()"
      (success)="handleSuccess($event)"
      [useGlobalDomain]="false"
      [size]="size"
      [hl]="lang"
      [theme]="theme"
      [type]="type"
      formControlName="recaptcha">
    </ngx-recaptcha2>
  </form>